import React from 'react';
import { Spin, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import usePermissionCache from '../../Hooks/usePermissionCache';
import './style.scss';

interface PermissionLoaderProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionLoader: React.FC<PermissionLoaderProps> = ({ 
  children, 
  fallback 
}) => {
  const { isLoading, cachedPermissions } = usePermissionCache();
  const { t } = useTranslation();

  // Show loading spinner while permissions are loading
  if (isLoading) {
    return (
      <div className="permission-loader">
        <Card className="loading-card">
          <div className="loading-content">
            <Spin size="large" />
            <p className="loading-text">
              {t('loading.permissions', 'Loading permissions...')}
            </p>
          </div>
        </Card>
      </div>
    );
  }


  // Render children when permissions are loaded
  return <>{children}</>;
};

export default PermissionLoader; 